import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { paramsFromState } from '@/utils/url-state/url-state';

type SerializableValue = string | number | boolean | null | undefined;

type UseUrlSyncOptions = {
  skip?: string[];
  defaults?: Record<string, SerializableValue>;
};

export function useUrlSync(
  state: Record<string, SerializableValue>,
  { skip, defaults }: UseUrlSyncOptions = {}
) {
  const [, setSearchParams] = useSearchParams();
  const optionsRef = useRef({ skip, defaults });
  optionsRef.current = { skip, defaults };

  const serialized = JSON.stringify(state);

  useEffect(() => {
    const next = paramsFromState(state, optionsRef.current);
    const current = new URLSearchParams(window.location.search);
    current.sort();
    if (current.toString() === next.toString()) return;
    setSearchParams(next, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serialized]);
}
